import React from 'react'
import { Link } from 'react-router-dom'
export var ODGNBTextLogo = function (_a) {
  var _b = _a.def,
    text = _b.text,
    url = _b.url
  return React.createElement(Link, { to: url || '#', className: 'od-logo-text' }, text)
}
//# sourceMappingURL=ODGNBTextLogo.js.map
